export enum AppRole {
  Admin = 'Admin',
  Marketing = 'Marketing',
  AreaManager = 'CapoArea',
  Agent = 'Agente',
}

export enum AppPermission {
  // Agenti e Clienti
  AGENTS_VIEW = 'AGENTS_VIEW',
  AGENTS_EDIT = 'AGENTS_EDIT',
  AGENTS_MANAGE_MANAGERS = 'AGENTS_MANAGE_MANAGERS',
  CUSTOMERS_VIEW = 'CUSTOMERS_VIEW',
  CUSTOMERS_EDIT = 'CUSTOMERS_EDIT',
  CUSTOMERS_DISCOUNTS_VIEW = 'CUSTOMERS_DISCOUNTS_VIEW',
  CUSTOMERS_DISCOUNTS_MANAGE = 'CUSTOMERS_DISCOUNTS_MANAGE',
  CUSTOMERS_COPY_DISCOUNTS = 'CUSTOMERS_COPY_DISCOUNTS',
  CUSTOMERS_PRICE_VISIBILITY_MANAGE = 'CUSTOMERS_PRICE_VISIBILITY_MANAGE',

  // Borsellino Azienda
  COMPANY_WALLETS_EDIT = 'COMPANY_WALLETS_EDIT',
  COMPANY_WALLETS_DELETE = 'COMPANY_WALLETS_DELETE',
  COMPANY_WALLETS_ADD_VALUE = 'COMPANY_WALLETS_ADD_VALUE',
  COMPANY_WALLETS_DOWNLOAD = 'COMPANY_WALLETS_DOWNLOAD',

  // Ordini
  ORDERS_VIEW = 'ORDERS_VIEW',
  ORDERS_DETAIL_VIEW = 'ORDERS_DETAIL_VIEW',
  FILTER_BY_MANAGER = 'FILTER_BY_MANAGER',

  // Promozioni e Marketing
  PROMOTIONS_VIEW = 'PROMOTIONS_VIEW',
  PROMOTIONS_MANAGE = 'PROMOTIONS_MANAGE',
  PROMOTIONS_ATTACHMENTS_EDIT = 'PROMOTIONS_ATTACHMENTS_EDIT',
  MARKETING_MANAGE = 'MARKETING_MANAGE',
  FORUM_VIEW = 'FORUM_VIEW',
  FORUM_MANAGE = 'FORUM_MANAGE',
  NOTIFICATIONS_PUSH_MANAGE = 'NOTIFICATIONS_PUSH_MANAGE',
  DOCUMENTS_MANAGE = 'DOCUMENTS_MANAGE',

  // Prodotti e Listini
  PRODUCTS_VIEW = 'PRODUCTS_VIEW',
  PRODUCTS_CATALOG_VIEW = 'PRODUCTS_CATALOG_VIEW',
  PRODUCTS_CATALOG_MANAGE = 'PRODUCTS_CATALOG_MANAGE',
  CATEGORIES_VIEW = 'CATEGORIES_VIEW',
  PRICELIST_VIEW = 'PRICELIST_VIEW',

  // App Features
  GIFT_CATALOGUE_VIEW = 'GIFT_CATALOGUE_VIEW',
  POINTS_MANAGE = 'POINTS_MANAGE',
  POINTS_APP_VIEW = 'POINTS_APP_VIEW',
  POINTS_CATEGORIES_VIEW = 'POINTS_CATEGORIES_VIEW',
  FEATURED_PRODUCTS_MANAGE = 'FEATURED_PRODUCTS_MANAGE',
  RELATED_PRODUCTS_MANAGE = 'RELATED_PRODUCTS_MANAGE',
  MARKETPLACE_CATEGORIES_MANAGE = 'MARKETPLACE_CATEGORIES_MANAGE',
  MARKETPLACE_CATEGORIES_VIEW = 'MARKETPLACE_CATEGORIES_VIEW',

  // Contabilita
  ACCOUNTING_VIEW = 'ACCOUNTING_VIEW',

  // Sistema
  USERS_MANAGE = 'USERS_MANAGE',
  APP_VERSIONS_VIEW = 'APP_VERSIONS_VIEW',

  // Mercatino
  MARKETPLACE_ANNOUNCEMENTS_MANAGE = 'MARKETPLACE_ANNOUNCEMENTS_MANAGE',
  MARKETPLACE_ANNOUNCEMENTS_VIEW = 'MARKETPLACE_ANNOUNCEMENTS_VIEW',

  // Report
  REPORT_VIEW = 'REPORT_VIEW',

  // Categorie manutenzione
  MAINTENANCE_CATEGORIES_MANAGE = 'MAINTENANCE_CATEGORIES_MANAGE',
}

export const ROLE_PERMISSIONS: Record<AppRole, AppPermission[]> = {
  [AppRole.Admin]: Object.values(AppPermission).filter(
    (p) =>
      p !== AppPermission.CUSTOMERS_DISCOUNTS_MANAGE &&
      p !== AppPermission.MARKETPLACE_ANNOUNCEMENTS_MANAGE &&
      p !== AppPermission.MARKETPLACE_CATEGORIES_MANAGE &&
      p !== AppPermission.MARKETPLACE_CATEGORIES_VIEW &&
      p !== AppPermission.FORUM_MANAGE,
  ),

  [AppRole.AreaManager]: [
    AppPermission.AGENTS_VIEW,
    AppPermission.AGENTS_EDIT,
    AppPermission.CUSTOMERS_VIEW,
    AppPermission.CUSTOMERS_EDIT,
    AppPermission.ORDERS_VIEW,
    AppPermission.PRODUCTS_VIEW,
    AppPermission.PROMOTIONS_VIEW,
    AppPermission.PROMOTIONS_MANAGE,
    AppPermission.CUSTOMERS_DISCOUNTS_VIEW,
    AppPermission.CUSTOMERS_DISCOUNTS_MANAGE,
    AppPermission.CUSTOMERS_COPY_DISCOUNTS,
    AppPermission.DOCUMENTS_MANAGE,
    AppPermission.REPORT_VIEW,
    AppPermission.ACCOUNTING_VIEW,
    AppPermission.COMPANY_WALLETS_DOWNLOAD,
  ],

  [AppRole.Marketing]: [
    AppPermission.CUSTOMERS_VIEW,
    AppPermission.CUSTOMERS_DISCOUNTS_VIEW,
    AppPermission.PRODUCTS_VIEW,
    AppPermission.PRODUCTS_CATALOG_VIEW,
    AppPermission.PRODUCTS_CATALOG_MANAGE,
    AppPermission.PROMOTIONS_VIEW,
    AppPermission.DOCUMENTS_MANAGE,
    AppPermission.PROMOTIONS_ATTACHMENTS_EDIT,
    AppPermission.PROMOTIONS_MANAGE,
    AppPermission.FILTER_BY_MANAGER,
    AppPermission.FORUM_VIEW,
    AppPermission.FORUM_MANAGE,
    AppPermission.NOTIFICATIONS_PUSH_MANAGE,
    AppPermission.POINTS_APP_VIEW,
    AppPermission.POINTS_MANAGE,
    AppPermission.FEATURED_PRODUCTS_MANAGE,
    AppPermission.RELATED_PRODUCTS_MANAGE,
    AppPermission.MARKETPLACE_ANNOUNCEMENTS_MANAGE,
    AppPermission.MARKETPLACE_ANNOUNCEMENTS_VIEW,
    AppPermission.MARKETPLACE_CATEGORIES_MANAGE,
    AppPermission.MARKETPLACE_CATEGORIES_VIEW,
    AppPermission.MAINTENANCE_CATEGORIES_MANAGE,
  ],
  [AppRole.Agent]: [],
};

/** Campi decodificati dal JWT — role è string perché il backend può inviare valori non enum */
export interface UserInfo {
  role: string | string[];
  email?: string;
  name?: string;
  nameid?: string;
  /** ID utente (claim standard JWT) */
  sub?: string;
  /** ID utente (claim custom .NET) */
  id?: string;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

/** Payload inviato al servizio di login */
export interface LoginRequest {
  phoneNumber: string;
  password: string;
}

/** Risposta restituita dal servizio di login */
export interface LoginResponse {
  message: string;
  statusCode: number;
  success: boolean;
  data: {
    email: string;
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
}

/** Token restituiti dall'endpoint di refresh */
export interface RefreshTokenData {
  accessToken: string;
  refreshToken: string;
}

export interface RefreshTokenResponse {
  success: boolean;
  data: RefreshTokenData;
}

/** Opzioni per il logout forzato (401, sessione scaduta, guard) */
export interface ForceLogoutOptions {
  message?: string;
  title?: string;
  redirectDelayMs?: number;
  showToast?: boolean;
  redirect?: boolean;
  enableHtml?: boolean;
}
